// Collapsible sections in the options panel.
//
// Every section starts open: the panel is the only place these controls live,
// so a section being hidden has to be the reader's own doing. The toggle is a
// real button inside the legend rather than a click handler on the legend
// itself, which is what makes it reachable by keyboard and announced as a
// disclosure.

export interface SectionState {
  /** Ids of the sections currently collapsed. */
  collapsed: string[]
}

export function initSections(
  form: HTMLElement,
  collapsed: readonly string[],
  onChange: (ids: string[]) => void,
): void {
  const hidden = new Set(collapsed)

  for (const section of form.querySelectorAll<HTMLFieldSetElement>('fieldset[id]')) {
    const toggle = section.querySelector<HTMLButtonElement>('legend .section-toggle')
    const body = section.querySelector<HTMLElement>('.section-body')
    if (!toggle || !body) continue

    if (!body.id) body.id = `${section.id}-body`
    toggle.setAttribute('aria-controls', body.id)

    const reflect = (isCollapsed: boolean) => {
      section.classList.toggle('collapsed', isCollapsed)
      toggle.setAttribute('aria-expanded', String(!isCollapsed))
      toggle.title = isCollapsed ? 'Show this section' : 'Hide this section'
    }
    reflect(hidden.has(section.id))

    toggle.addEventListener('click', () => {
      const next = !section.classList.contains('collapsed')
      reflect(next)
      if (next) hidden.add(section.id)
      else hidden.delete(section.id)
      onChange([...hidden])
    })
  }
}
